module.exports = __webpack_public_path__ + "img/android-test-code.bb68998.png";